var _ellipse, _ellipse2, _path, _path2, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 61.5,
    rx: 33,
    ry: 27.5,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 34,
    rx: 32,
    ry: 27,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08844 93.3139L11.8154 76.9319L24.0944 86.1986L9.08844 93.3139Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7528 66.0825L75.8557 58.7419L88.273 49.6613L90.7528 66.0825Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_2329_16606)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2329_16606",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2329_16606",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2329_16606",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAM1BMVEVHcEz+zgn+zgn+zgn+zgn+zgn+zgn+zgn+zgn+zgn+zgn+zgn+zgn+zgn+zgn+zgn+zgnvPua7AAAAEHRSTlMADLWN8frmyDcXRV6iJ9d4Ijtu9AAABS1JREFUaN7tWdt24zAIjND9nv//2hXIieXUiiUlfdry0NOcNsYMCIbR7fZnfzZjLPrMQSsllNLAs49fd2Gd5wBJyTuaVAkC98Z+1UOGVB/fmkwhuy/5iT6o5slSyMafCt58IQoP9/pQkTQUkHLOPADoJDY/On+YHebC9sYaoWH7HwqEQW8p0v4T0GwWNYZw+hjrwxYPGLbqw0DNL+/jEXN1ozxbhArzLUV4DznLtfD4EmQeX1HCdfFYTtWnF8os4/vJsfdzmmCd9uIlIT1aIWElFodYJTeeQE5epk5MRJSVmykTThmc+QbWrnBzxZgph+P/TwnxsyeXz2SxgsWnT5fF+LWdgDctnC2XxgEzJRDpV84vpkXF0Qy2ZRK3mEwxd/Zjf2rUo6HEdKgsD+CoIWudtD79sTdHj6GMAF3+UerDy0F5iLn3TZhDKH6sEkU+OAnoRI44eYW6i1Z5qmqa0AMurnsGea92U9qRuMYLp0hqzwjbPtiutTggXmYoJWF9YPOhXpEPKZkfddgs3p6QEnoM6KT8wtaGtnvnhLHoCp8iliORYoVsVhxhqYceheNa/KChCnKcdYOlfurE8NQ9AjDJdTpOHOzkVijqFfpB34kfZHNhl3A5ENs6oDELJQ1opQDKqlABlOLKgn2b+Bi2V4afaWbFURD3ETPNUC0fjyfAV/KXeMulD35MTtc+UjxyI/+T+akc7bstbnMjQuYdMy9tpRlbESqHvSTkhhOZBMvOWxd7KS7FXih7GlktrE8Uih2bqntxGaSv9zBILOsbgR2Zqnd38CH5MK2MRHYvY8Haes6JSBQxs8kefkXGaPrmJ7OSkz7KdygWf8lUn4QN9xs5SxErQXwHsElNIJSeME0Rr9jrkaaGAlZaWL4QgD7XZwfCjQuOWKKh+HY9BBjufzt9BLkC1gOwXiiUZ3iWL35yt9tqKJ2shMPSiOULizoFEv7zAsOsNxuQXtiirr+Mx3sPBNOelnUdLl5nUrPK71sWFkEjAbAMuRYg9KztcL7gdaqD4EHck4C58+3CLqleuJBda4iBTccjZh/SHXbcPVtaNs249k2/FUfPgB2S8ihiZjwotbnEnOze1XGtiyAoSqN7XETqNtOAW05hmx41NWIhVbfA/rlXl3gpQrtporFLqw4sEtFWhZcp8WRmito5b2fiff2UPJw0RrEIXJNcm63vOVHAvfHEeFJwSIaeochx1aDnRGlUVb0jHEnrQje6acIfnUWqQplNbHiQ4Y1svKlXY0td1+BnH7Yu7DRTnx3GWfUznelgzHFQrRNswi2FsO7K4stuDPFUbEfdG4J7Dpfm3wqvvzJwxwbZHfPsSVmtOswsP7AZwKGrDAlI4YCXu95AZGDt0BqiIDRQzC7H6ytrWvub8ftiaXk0RjVMD/AqQZvV4z7Ic7DWF3TMArSc4DnY1BbYnZ1it6Qtz/NUGJYxd8YNk22SNscZfQIBk3NUlW6epr5CW5Dysz7mbhXqLjGunVmSJqbTiH1yWAV0tPLPny2c+zCWRVuVKpg/vy4NEgrmq3IRFmZ268T29bnHxa9auuFrcuLKQDu99o4ub5oXrDVU/qwuR8KJDty7wkLspqkZlzmkz66QsbNQ+2J+JzTIpwKJSyirPkaW5qvkxte9jFWZSXTVfrXuggIp6/AmmClekFGvc1gKpcMnl+AZmz2vLmTyVEZlF0gpVYJSftEhf3TNfqv30w/aHFtt0/liWAG3D82mHRLtb79jTu0u2O23LNCeprP5PRd/9j/aP8WYbaqObiU6AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivechat);
export default __webpack_public_path__ + "static/media/livechat.de4b6afd7fafd0c689b9f616f2dac1d1.svg";
export { ForwardRef as ReactComponent };